export interface Stat {
  value: string;
  label: string;
  description: string;
  icon: string;
}

export const companyStats: Stat[] = [
  {
    value: '10+',
    label: 'Years Experience',
    description: 'Combined industry experience',
    icon: 'Calendar',
  },
  {
    value: '50+',
    label: 'Projects Completed',
    description: 'Residential & commercial projects',
    icon: 'CheckCircle',
  },
  {
    value: 'Islandwide',
    label: 'Service Coverage',
    description: 'Across Jamaica',
    icon: 'MapPin',
  },
  {
    value: 'OSHA',
    label: 'Safety Certified',
    description: '29 CFR 1926 Compliant',
    icon: 'ShieldCheck',
  },
];

export const budgetRanges = [
  'Under $5 Million JMD',
  '$5 - $15 Million JMD',
  '$15 - $30 Million JMD',
  '$30 - $50 Million JMD',
  '$50 - $100 Million JMD',
  'Over $100 Million JMD',
];

export const jamaicaParishes = [
  'Kingston',
  'St. Andrew',
  'St. Thomas',
  'Portland',
  'St. Mary',
  'St. Ann',
  'Trelawny',
  'St. James',
  'Hanover',
  'Westmoreland',
  'St. Elizabeth',
  'Manchester',
  'Clarendon',
  'St. Catherine',
];
